
<v-sheet>
	<v-navigation-drawer :value="value" fixed app @input="$emit('input', $event)">
		<v-list-item>
			<v-list-item-avatar v-if="!avatar">
				<v-img :src="no_avatar"></v-img>
			</v-list-item-avatar>
			<v-list-item-avatar v-else size="56">
				<v-img :src="avatar"></v-img>
			</v-list-item-avatar>

			<v-list-item-content>
				<v-list-item-title>{{ usersName }}</v-list-item-title>
				<v-list-item-subtitle>{{ usersProfession }}</v-list-item-subtitle>
			</v-list-item-content>
		</v-list-item>

		<v-divider></v-divider>

		<v-list dense>
			<template v-for="item in items">
				<v-list-item v-if="!item.hidden" :key="item.title" value="item.active" link>
					<v-list-item-content>
						<v-list-item v-if="item.onClick" slot="item" color="primary" class="text-center" @click="item.onClick">{{ item.title }}</v-list-item>
						<v-list-item v-else slot="item" router :to="item.to" :href="item.href" :target="item.target" color="primary" class="text-center">{{
							item.title
						}}</v-list-item>
					</v-list-item-content>
				</v-list-item>
			</template>
		</v-list>
		<v-spacer></v-spacer>
		<v-list>
			<v-list-item>
				<v-btn block :loading="apiRequest" color="secondary" @click="signOut">Sign Out</v-btn>
			</v-list-item>
		</v-list>
	</v-navigation-drawer>
</v-sheet>
